import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

interface Step1BasicInfoProps {
    formData: any;
    setFormData: (data: any) => void;
    file: File | null;
    fileName: string;
    onFileChange: (file: File) => void;
    documentTypeOptions: any[];
    onShowEditor?: () => void;
    onEditEditor?: () => void;
    editorCreating?: boolean;
    fileId?: string | null;
    readonly?: boolean;
    errors?: any;
}

export const Step1BasicInfo: React.FC<Step1BasicInfoProps> = ({
    formData,
    setFormData,
    file,
    fileName,
    onFileChange,
    documentTypeOptions,
    onShowEditor,
    onEditEditor,
    editorCreating,
    fileId,
    readonly = false,
    errors = {}
}) => {
    return (
        <div className="grid">
            <div className="col-12 md:col-6 field">
                <label className="font-bold block mb-1">Mã tài liệu mẫu (<span className="text-red-500">*</span>)</label>
                <InputText
                    value={formData.agreementPseudoId}
                    onChange={e => setFormData({ ...formData, agreementPseudoId: e.target.value })}
                    className={`w-full ${errors.agreementPseudoId ? 'p-invalid' : ''}`}
                    disabled={readonly}
                />
                {errors.agreementPseudoId && <small className="p-error block mt-1">{errors.agreementPseudoId}</small>}
            </div>
            <div className="col-12 md:col-6 field">
                <label className="font-bold block mb-1">Tên tài liệu mẫu (<span className="text-red-500">*</span>)</label>
                <InputText
                    value={formData.agreementName}
                    onChange={e => setFormData({ ...formData, agreementName: e.target.value })}
                    className={`w-full ${errors.agreementName ? 'p-invalid' : ''}`}
                    disabled={readonly}
                />
                {errors.agreementName && <small className="p-error">{errors.agreementName}</small>}
            </div>
            <div className="col-12 field">
                <label className="font-bold block mb-1">Loại tài liệu (<span className="text-red-500">*</span>)</label>
                <Dropdown
                    value={formData.agreementPartyTypeConfId}
                    options={documentTypeOptions}
                    filter
                    filterBy="label"
                    showClear
                    onChange={e => setFormData({ ...formData, agreementPartyTypeConfId: e.value })}
                    className={`w-full ${errors.agreementPartyTypeConfId ? 'p-invalid' : ''}`}
                    placeholder="Chọn loại tài liệu"
                    disabled={readonly}
                />
                {errors.agreementPartyTypeConfId && <small className="p-error">{errors.agreementPartyTypeConfId}</small>}
            </div>
            <div className="col-12 field">
                <label className="font-bold block mb-1">Mô tả</label>
                <InputTextarea
                    value={formData.description}
                    onChange={e => setFormData({ ...formData, description: e.target.value })}
                    rows={3}
                    className="w-full"
                    disabled={readonly}
                />
            </div>
            <div className="col-12 field">
                <label className="font-bold block mb-1">Tệp mẫu (.docx) (<span className="text-red-500">*</span>)</label>
                <div className="p-inputgroup">
                    <InputText value={fileName || file?.name || ''} placeholder="Chưa có tệp" className={errors.file ? 'p-invalid' : ''} disabled />
                    {!readonly && (
                        <>
                            <Button icon="pi pi-upload" severity="info" onClick={() => {
                                const input = document.createElement('input');
                                input.type = 'file';
                                input.accept = '.docx,.doc';
                                input.onchange = (e: any) => {
                                    const f = e.target.files[0];
                                    if (f) onFileChange(f);
                                };
                                input.click();
                            }} />
                            {onShowEditor && !fileId && (
                                <button className="p-button p-component p-button-success p-button-icon-only" onClick={onShowEditor} disabled={editorCreating} title="Soạn thảo mới">
                                    {editorCreating ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-file-edit"></i>}
                                </button>
                            )}
                            {onEditEditor && fileId && (
                                <Button icon="pi pi-pencil" severity="warning" onClick={onEditEditor} title="Chỉnh sửa nội dung" />
                            )}
                        </>
                    )}
                </div>
                {errors.file && <small className="p-error block mt-1">{errors.file}</small>}
            </div>
        </div>
    );
};
